/**
 * Centralized copy for the Access tab inside Customer Information
 * (abo-hide-books-rm, ADR-005 option C). The tab is a stack of independently
 * gated sections; today it holds "Member app sections" (show or hide Books
 * and Magazines in the member app). Kept out of the component per the repo
 * rule that feature text is not hardcoded inline (mirrors
 * MemberCreditsTab.strings.ts). Placeholders use `{token}` and are filled
 * with `formatMessage`.
 */
export { formatMessage } from "./MemberBooksTab.strings";

export const memberAccessStrings = {
  tabTitle: "Access",
  memberApp: {
    heading: "Member app sections",
    description: "What this member can open in the member app.",
    loadError: "Could not load this member's app sections. Please try again.",
    notFound: "This member was not found in DigitalServices.",
    retry: "Try again",
    sections: {
      books: {
        name: "Books",
        description: "Books menu and My books card",
      },
      magazines: {
        name: "Magazines (Referral Marketing)",
        description: "Magazines menu and My magazines card",
      },
    },
    values: {
      shown: "Shown",
      hidden: "Hidden",
    },
    // Under the chip: why the member gets that value.
    notSet: "Not set, follows the old flag",
    setByOperator: "Set by an operator",
    lastChange: "{value} by {operator} on {date}",
    switchLabel: "{section} in the member app",
    unsaved: "Unsaved",
    hint: "Subscriptions suggest: {hint}",
    hints: {
      "rm-only": "RM only",
      "books-only": "Books only",
      both: "Both",
      unknown: "Unknown",
    },
    notes: {
      nextSignIn: "Applies at the member's next sign-in.",
      bookAccess: "Books also needs book access.",
    },
    caseVariant:
      "Changes apply to record {targetId}, which shares this e-mail.",
    saveBar: {
      one: "{count} unsaved change",
      other: "{count} unsaved changes",
      discard: "Discard",
      save: "Save changes",
    },
    dialog: {
      titleOne: "Save {count} change for {name}?",
      titleOther: "Save {count} changes for {name}?",
      change: "{section}: {from} → {to}",
      body: "Each change is recorded in Activity under your name.",
      confirm: "Confirm",
      cancel: "Cancel",
      signInAgain: "Sign in again",
    },
    refusals: {
      ABO_OPERATOR_UNVERIFIED:
        "Your sign-in could not be verified. Sign in again, then save.",
      ABO_OPERATOR_UNAVAILABLE:
        "Saving is not available right now: operator sign-in checks are not set up. Try again later.",
      CUSTOMER_NOT_FOUND: "This member was not found in DigitalServices.",
      REQUEST_FAILED: "Could not save the changes. Please try again.",
    },
  },
} as const;
